import script from "./downline-settlement.vue?vue&type=script&setup=true&lang=js"
export * from "./downline-settlement.vue?vue&type=script&setup=true&lang=js"

import "./downline-settlement.vue?vue&type=style&index=0&id=8cd1b940&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./downline-settlement.vue?vue&type=style&index=1&id=8cd1b940&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cd1b940"]])

export default __exports__